/**
 * Website or Android app. The app (apps/mobile) bundles this client and serves it from its own origin
 * (https://localhost in the WebView), so it talks to the API on another origin with a bearer token instead of
 * the session cookie. Both flags are compile-time constants (vite.config.ts), so the website build carries none
 * of the app's code.
 */
export const isNative: boolean = __NATIVE__;

/** Where the API lives: '' (same origin) on the website, https://chat.spawnwire.online in the app. */
export const API_ORIGIN: string = __API_ORIGIN__;

/** Absolute URL for an API or socket path. */
export function apiUrl(path: string): string {
  return `${API_ORIGIN}${path}`;
}

/** The public site, for links people share (invites, message links). */
export function publicOrigin(): string {
  return isNative ? API_ORIGIN : location.origin;
}

let authToken: string | null = null;

/** The app's session token (kept in the Android Keystore by the native layer). Always null on the website. */
export function getAuthToken(): string | null {
  return authToken;
}

export function setAuthToken(token: string | null): void {
  authToken = token;
}
